import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Button, Icon } from 'antd';
import {connect} from 'react-redux';
import {fetchContractors} from '../../../actions';
import PaginatedList from '../../PaginatedList';

class Admins extends Component {
    render() {
        const {fetchContractors, contractors, landlord, match, location: {search}} = this.props;
        const columns = [{
            title: 'Business Name',
            dataIndex: 'business_name',
            key: 'business_name',
            render: (text, record) => (
                <span>
                    <Link to={{
                        pathname: `${match.url}/${record.id}/edit`,
                        state: {
                            from: search || 'page=1'
                        }
                    }}>{text}</Link>
                </span>
            )
        }, {
            title: 'Address Line 1',
            dataIndex: 'address_line_1',
            key: 'address_line_1'
        }, {
            title: 'Address Line 2',
            dataIndex: 'address_line_2',
            key: 'address_line_2'
        }, {
            title: 'Post Code',
            dataIndex: 'post_code',
            key: 'post_code'
        }, {
            title: 'Contact Name',
            dataIndex: 'contact_name',
            key: 'contact_name'
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email'
        }, {
            title: 'Phone Number',
            dataIndex: 'phone_number',
            key: 'phone_number'
        }, {
            title: 'Gas Safe Number',
            dataIndex: 'gas_safe_number',
            key: 'gas_safe_number'
        }];

        const fetch = (id) => {
            return fetchContractors(landlord, id);
        };
        return (
            <div>
                <Button style={{marginBottom: 10}} type="primary">
                    <Link to={`${match.url}/new`}><Icon type="plus"/> New</Link>
                </Button>
                <PaginatedList
                    fetchData={fetch}
                    columns={columns}
                    source={contractors}
                    {...this.props}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const contractors = state.landlord.contractors;
    return {
        landlord: state.me.application.id,
        contractors: [...contractors.data],
        meta: contractors.meta,
        loading: contractors.isFetching,
    };
};

export default connect(mapStateToProps, {fetchContractors})(Admins);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/contractor/Contractors.js